import { gql } from '@apollo/client';

export const GET_EMAIL_NOTIFICATIONS_QUERY = gql`
  query GetEmailNotificationsQuery($agentID: ID!) {
    getEmailNotifications(agentID: $agentID) {
      defaultFrequency
      frequencies
      name
    }
  }
`;
